import { Title3, Card, CardHeader, Body1Strong, Body2 } from '@fluentui/react-components'
import { Checkmark16Regular } from '@fluentui/react-icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Tip {
    title: string;
    tips: string[];
}

const TipsSection : React.FC<any> = ({styles}) => {
  const { t } = useTranslation();

  const tips : Tip[] = [
    {
        title: t('info.tips.attachments.title', 'Using Attachments'),
        tips: [
            t('info.tips.attachments.1', 'Select the entire range including headers, then click the + button to attach data to your message'),
            t('info.tips.attachments.2', 'The AI automatically detects column headers and source cell addresses, ensuring accurate formula generation'),
            t('info.tips.attachments.3', 'The attachment preview shows column letters (e.g. G — Units Sold) so you can verify the mapping before sending'),
            t('info.tips.attachments.4', 'Works correctly with any number of columns — column letter mappings are explicit, so the AI does not need to count columns'),
        ]
    },
    {
        title: t('info.tips.security.title', 'Security Best Practices'),
        tips: [
            t('info.tips.security.1', 'Use environment variables or secure storage for API keys in production'),
            t('info.tips.security.2', 'Regularly rotate your API keys'),
            t('info.tips.security.3', 'Set up spending limits in your provider dashboard'),
            t('info.tips.security.4', 'Review access logs for unusual activity'),
        ]
    },
    {
        title: t('info.tips.cost.title', 'Cost Management'),
        tips: [
            t('info.tips.cost.1', 'Start with cheaper models (GPT-3.5) for testing'),
            t('info.tips.cost.2', 'Use smaller context windows when possible'),
            t('info.tips.cost.3', 'Implement caching for repeated queries'),
            t('info.tips.cost.4', 'Set up budget alerts in your provider account')
        ]
    },
  ];

  return (
      <div className={styles.section}>
        <Title3>
          <Checkmark16Regular className={styles.sectionIcon} />
          {t('info.tips.title', 'Tips & Best Practices')}
        </Title3>

        <div style={{marginTop: "10px"}}>
            {
                tips.map(item =>
                    <Card key={item.title} className={styles.tipsCard}>
                        <CardHeader
                            header={<Body1Strong>{item.title}</Body1Strong>}
                        />
                        <Body2>
                            <ul className={styles.tipsList}>
                                {item.tips.map(tip => <li key={tip}>{tip}</li>)}
                            </ul>
                        </Body2>
                    </Card>
                )
            }
        </div>
      </div>
  )
}

export default TipsSection